import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useTitle} from '../../dashboard/TitleContext';
import {useSnackbar} from '../../../util/SnackbarProvider';
import productProjectIterationService from "../../../services/ProductProjectIteratlonService";
import ProductProjectIterationEditorTemplate from "./ProductProjectIterationEditorTemplate";
import productProjectService from "../../../services/ProductProjectService";
import {useLocalNavigation} from "../../dashboard/LocalNavigationContext";
import {Ballot, History, MoveDown, Storage} from "@mui/icons-material";

const ProductProjectIterationEditor = () => {

    const urlParts = window.location.pathname.split('/')
    const productProjectId = urlParts[3] === 'create' ? undefined : urlParts[3]
    const id = urlParts[5] === 'create' ? undefined : urlParts[5]

    useTitle([
        {name: 'Termék Projekt Lista', url: '/dashboard/product-projects'},
        {name: 'Termék Projekt', url: '/dashboard/product-projects/' + (productProjectId || 'create')},
        {name: 'Gyártási ciklus', url: '/dashboard/product-projects/' + productProjectId + '/iterations/' + (id || 'create')},
    ])

    useLocalNavigation([
        {title: 'Alraktárak', url: '/dashboard/storage/substorages', icon: <Storage/>},
        {title: 'Termékek Mozgatása', url: '/dashboard/storage/move', icon: <MoveDown/>},
        {title: 'Raktár Történet', url: '/dashboard/storage/logs', icon: <History/>},
        {title: 'Feladatkörök', url: '/dashboard/task-types', icon: <Ballot/>},
    ])

    const [iteration, setIteration] = useState();
    const {sendAlertMessage} = useSnackbar()
    const [waitingForServer, setWaitingForServer] = useState(false)
    const [message, setMessage] = useState('')
    const navigate = useNavigate()
    const [chatMessage, setChatMessage] = useState('')

    useEffect(() => {
        if (!id) return
        retrieveProductProjectIteration()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    function retrieveProductProjectIteration() {
        productProjectIterationService.findById(id)
            .then(response => {
                const fixedResponse = {
                    ...response,
                    customerNames: Array.isArray(response.customerNames) && response.customerNames.length > 0
                        ? response.customerNames
                        : ['']
                };
                setIteration(() => fixedResponse);
            })
            .catch(error => sendAlertMessage(error?.message || 'Termék projekt lekérése sikertelen', 'error'))
    }

    const [productProject, setProductProject] = useState()
    useEffect(() => {
        productProjectService.findById(productProjectId)
            .then(response => {
                setProductProject(() => (response))
            })
            .catch(error => console.log(error))
    }, [productProjectId]);

    const [iterationOptions, setIterationOptions] = useState()
    useEffect(() => {
        id ?
            productProjectService.getIterationOptions(productProjectId, id)
                .then(response => setIterationOptions(response))
                .catch(error => console.error(error))
            :
            productProjectService.getNewIterationOptions(productProjectId)
                .then(response => setIterationOptions(response))
                .catch(error => console.error(error))
    }, [productProjectId, iteration]);

    const onChange = (e, v, n) => {
        const name = n || e.target.name
        const value = v || e.target.value
        setIteration((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const onCustomerChange = (event, itemIndex) => {
        const {value, name} = event.target;
        setIteration((prev) => {
            const updated = prev.customers.map((item, index) => {
                if (index === itemIndex) {
                    return {...item, [name]: value};
                }
                return item;
            });

            return {
                ...prev,
                customers: updated,
            };
        });
    }

    const create = (e) => {
        e.preventDefault();
        setWaitingForServer(true)
        productProjectIterationService.create(productProjectId, prepareRequest())
            .then(() => {
                navigate(-1)
                sendAlertMessage('Gyártási ciklus sikeresen létrehozva')
            })
            .catch((error) => setMessage(error?.message))
            .finally(() => setWaitingForServer(false))
    };

    const update = (e) => {
        e.preventDefault();
        setWaitingForServer(true)
        productProjectIterationService.update(id, prepareRequest())
            .then(() => {
                sendAlertMessage('Gyártási ciklus sikeresen mentve')
                retrieveProductProjectIteration()
            })
            .catch(error => setMessage(error?.message))
            .finally(() => setWaitingForServer(false))
    };

    const close = () => {
        productProjectIterationService.close(id)
            .then(() => retrieveProductProjectIteration())
            .catch(error => setMessage(error?.message))
    }

    const prepareRequest = () => {
        const copy = structuredClone(iteration)
        delete copy.serialNumber
        delete copy.createdAt
        delete copy.updatedAt
        delete copy.productProject
        return copy
    }

    const changeItemPlannedAmount = (itemId, value) => {
        setIterationOptions(prev => ({
            ...prev,
            productItems: (prev.productItems.map(item => item.id === itemId ? {...item, plannedAmount: value} : item))
        }));
    };

    const addNewCustomer = () => {
        setIteration(prev => ({
            ...prev,
            customers: [...(prev?.customers || []), '']
        }))
    }

    const deleteLastCustomer = () => {
        setIteration(prev => {
            const updated = [...prev.customers.slice(0, -1)];
            return {
                ...prev,
                customers: updated
            };
        })
    }


    return (
        <ProductProjectIterationEditorTemplate
            {...{
                id,
                iteration,
                message,
                onChange,
                create,
                update,
                navigate,
                waitingForServer,
                chatMessage,
                sendAlertMessage,
                productProject,
                iterationOptions,
                changeItemPlannedAmount,
                addNewCustomer,
                deleteLastCustomer,
                onCustomerChange,
                retrieveProductProjectIteration,
                close
            }}
        />
    );
};

export default ProductProjectIterationEditor;
